module.exports = __webpack_public_path__ + "img/9788932022703.a85641ae.jpg";